export const resolveAuthContinuePath = (continueUrl?: string | null) => {
  if (!continueUrl || !continueUrl.startsWith("/") || continueUrl.startsWith("//")) {
    return "/"
  }

  return continueUrl
}

export const buildAuthContinueUrlFromBase = (baseUrl: string, continueUrl?: string | null) => {
  const resolvedPath = resolveAuthContinuePath(continueUrl)
  const normalizedBaseUrl = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`
  const relativePath = resolvedPath === "/" ? "" : resolvedPath.slice(1)

  return new URL(relativePath, normalizedBaseUrl).toString()
}

export const buildAuthContinueUrl = (continueUrl?: string | null) =>
  buildAuthContinueUrlFromBase(import.meta.env.VITE_BASE_URL, continueUrl)
